import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-flex h-flex-space-between h-flex-dir-column" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "h-text-center h-mb-20" }
const _hoisted_4 = { class: "b-base-title h-mt-10 h-fw-700" }
const _hoisted_5 = { class: "h-mt-10 h-mb-20 h-text-center h-fw-400" }
const _hoisted_6 = { class: "h-flex h-flex-center h-width-100p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.requireImage("forgot-password.svg")
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('AUTH.FORGET_PASSWORD.TITLE')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('AUTH.FORGET_PASSWORD.ASIDE')), 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_FwFormInput, {
        class: "h-mb-25",
        fieldHasError: _ctx.fieldHasErrorByRule(_ctx.email, _ctx.EMAIL, _ctx.emailRules),
        labelType: "label-thin",
        title: _ctx.$t(`AUTH.SIGN_UP.FORM.EMAIL.LABEL`)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FwInput, {
            value: _ctx.email,
            type: "text",
            name: "text",
            inputStyle: "gray",
            placeholder: "adresse@email.com",
            error: _ctx.getFieldErrorTextByRule(_ctx.email, _ctx.EMAIL, _ctx.emailRules),
            iconRight: "edit",
            onUpdate: _cache[0] || (_cache[0] = value => _ctx.email = value),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearServerErrorsBase(_ctx.EMAIL))),
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addCurrentInputToValidateArray(_ctx.EMAIL)))
          }, null, 8, ["value", "error"])
        ]),
        _: 1
      }, 8, ["fieldHasError", "title"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_FwButton, {
        class: "h-mt-30",
        disabled: !_ctx.isFormValid,
        borderRadiusType: "small-border",
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('AUTH.FORGET_PASSWORD.BUTTON')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}